(function () {
  var COOKIE_NAME = 'age_verified';
  var COOKIE_DAYS = 30;
  var EXIT_URL = 'https://www.google.com';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.getElementById('age-gate');
    if (!gate) return;

    var alreadyVerified = getCookie(COOKIE_NAME) === 'true';

    if (alreadyVerified) {
      gate.remove();
      return;
    }

    gate.classList.add('is-visible');
    document.body.classList.add('age-gate-locked');

    var confirmBtn = document.getElementById('age-gate-confirm');
    var denyBtn = document.getElementById('age-gate-deny');

    confirmBtn.addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
      gate.classList.remove('is-visible');
      document.body.classList.remove('age-gate-locked');
      setTimeout(function () {
        gate.remove();
      }, 300);
    });

    denyBtn.addEventListener('click', function () {
      window.location.href = EXIT_URL;
    });
  });
})();